import { IconToggleStarOff16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as style from './style.css';

export interface IAgentReviewsTitleProps {
  title: string;
  link: string | null;
}

export const AgentReviewsTitle: React.FC<React.PropsWithChildren<IAgentReviewsTitleProps>> = ({ title, link }) => {
  const JSXElement = link ? 'a' : 'div';

  return (
    <JSXElement className={style['agent-reviews-title']} href={link ? `${link}#reviews` : undefined}>
      <IconToggleStarOff16 color="icon-warning-default" />
      {title}
    </JSXElement>
  );
};
